import urls from "./urls.jsx";

/**
 * Base changelog route builder.
 * Filters with null or undefined values are omitted.
 */
export function changelogRoute(filters = {}) {
    const search = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
        if (value != null) {
            search.set(key, value);
        }
    });

    return {
        pathname: urls.changelogs(),
        search: search.toString(),
    };
}

/**
 * Changelog filtered to routines.
 */
export function routineChangelogRoute({
    organizationId,
    locationId,
    routineId,
} = {}) {
    return changelogRoute({
        collection: "routines",
        organizationId,
        locationId,
        routineId,
    });
}

/**
 * Changelog filtered to drone configs.
 */
export function droneConfigChangelogRoute({ droneId } = {}) {
    return changelogRoute({
        collection: "droneConfigs",
        droneId,
    });
}

/**
 * Changelog filtered to apps.
 */
export function appChangelogRoute({ appId } = {}) {
    return changelogRoute({
        collection: "apps",
        appId,
    });
}
